import React, { FC } from 'react';

export const HelpCenterIframe = () => {
  return (
    <iframe
      title="Help Center"
      height="100%"
      className="w-full"
      id="iframe"
      style={{ width: '100%' }}
      src="https://atlas-kb.com/superorder-demo"
      // srcDoc="https://atlas-kb.com/superorder-demo"
      scrolling="yes"
      frameBorder="0"
    />
  );
};

const HelpCenter: FC = () => {
  return (
    <div>
      <div style={{ height: '80vh' }}>
        <HelpCenterIframe />
      </div>
    </div>
  );
};

export default HelpCenter;
